export const BASE_NAME = '@@FCC-ADMIN/USERDETAIL';

export const USERDETAIL_REQUEST = `${BASE_NAME}/USERDETAIL/REQUEST`;
export const USERDETAIL_SUCCESS = `${BASE_NAME}/USERDETAIL/SUCCESS`;
export const USERDETAIL_FAILURE = `${BASE_NAME}/USERDETAIL/FAILURE`;
export const USERDETAIL_RESET = `${BASE_NAME}/USERDETAIL/RESET`;

export const USERSTATUS_REQUEST = `${BASE_NAME}/USERSTATUS/REQUEST`;
export const USERSTATUS_SUCCESS = `${BASE_NAME}/USERSTATUS/SUCCESS`;
export const USERSTATUS_FAILURE = `${BASE_NAME}/USERSTATUS/FAILURE`;
export const USERSTATUS_RESET = `${BASE_NAME}/USERSTATUS/RESET`;

export const USERANALYTICS_REQUEST = `${BASE_NAME}/USERANALYTICS/REQUEST`;
export const USERANALYTICS_SUCCESS = `${BASE_NAME}/USERANALYTICS/SUCCESS`;
export const USERANALYTICS_FAILURE = `${BASE_NAME}/USERANALYTICS/FAILURE`;

export const UPDATE_CLIENT_VERIFICATION_REQUEST = `${BASE_NAME}/UPDATE/CLIENT/VERIFICATION/REQUEST`;
export const UPDATE_CLIENT_VERIFICATION_SUCCESS = `${BASE_NAME}/UPDATE/CLIENT/VERIFICATION/SUCCESS`;
export const UPDATE_CLIENT_VERIFICATION_FAILURE = `${BASE_NAME}/UPDATE/CLIENT/VERIFICATION/FAILURE`;
export const UPDATE_CLIENT_VERIFICATION_RESET = `${BASE_NAME}/UPDATE/CLIENT/VERIFICATION/RESET`;

export const MANAGE_OWNERSHIP_REQUEST = `${BASE_NAME}/MANAGE/OWNERSHIP/REQUEST`;
export const MANAGE_OWNERSHIP_SUCCESS = `${BASE_NAME}/MANAGE/OWNERSHIP/SUCCESS`;
export const MANAGE_OWNERSHIP_FAILURE = `${BASE_NAME}/MANAGE/OWNERSHIP/FAILURE`;

export const CLOSE_CLIENT_REMOVED_REQUEST = `${BASE_NAME}/CLOSE/CLIENT?REMOVED/REQUEST`;
export const CLOSE_CLIENT_REMOVED_SUCCESS = `${BASE_NAME}/CLOSE/CLIENT?REMOVED/SUCCESS`;
export const CLOSE_CLIENT_REMOVED_FAILURE = `${BASE_NAME}/CLOSE/CLIENT?REMOVED/FAILURE`;

export const REDUX_KEY = 'userdetail';
